export const ROOT_NODE = '$'

const ROOT_NODE_PREFIX = '$.'

export function displayNode (node: string): string {
  if (node === ROOT_NODE) return 'Root'
  if (node.startsWith(ROOT_NODE_PREFIX)) return node.slice(ROOT_NODE_PREFIX.length)
  return node
}

export function displayAttribute (node: string, fullPath: string): string {
  const prefix = `${node}.`

  return fullPath.startsWith(prefix)
    ? fullPath.slice(prefix.length)
    : fullPath
}
